import React from 'react'
import { Menu } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const EmptyContent = styled.div`
  padding: 20px;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
`

const MenuWrapper = styled.div`
  .ui.menu {
    border-radius: 0;
    border: 0;

  }

  .ui.vertical.menu {
    box-shadow: 0 0 0 0 rgba(34,36,38,.15);
    .item>.menu {
      margin: 5px 0px 0px 0px;
    }
    .item:before {
      width: 0%;
    }
  }

  .header-menu {
    cursor: pointer;
    padding: 10px 7px;
  }
`

const ThemeCategoryMenus = (props) => {
  const {
    menuId,
    categoryTitle,
    lang,
    backgroundColor,
    menu,
  } = props

  const handleItemClick = ({ url, target = '_self' }) => {
    const { goto } = props
    if (url) {
      goto({ href: url, target })
    }
  }

  if (!menu || !menu.length > 0) {
    return (
      <EmptyContent>
        Loading...
      </EmptyContent>
    )
  }

  const selectedMenu = (menu.find((eachMenu) => eachMenu.id === menuId) || {}).data
  const selectedCategory = selectedMenu ?
    (selectedMenu.find((category) => category.title === categoryTitle) || {}) : undefined
  const categories = selectedCategory ? (selectedCategory.children || []) : undefined

  if (!categoryTitle || categoryTitle === '') {
    return (
      <EmptyContent style={{ background: backgroundColor }}>
        Please Select Menu and Category.
      </EmptyContent>
    )
  }

  if (!categories || !(categories.length > 0)) {
    return (
      <EmptyContent style={{ background: backgroundColor }}>
        Cannot find Category.
      </EmptyContent>
    )
  }

  return (
    <MenuWrapper>
      <Menu vertical className="sub-categories-menu">
        {
          categories.map((category) => (
            <Menu.Item key={category.title}>
              <div
                role="presentation"
                className="header-menu"
                onClick={() => handleItemClick({
                  url: category.url,
                  target: category.target,
                })}
              >
                {category.name[lang]}
              </div>
              {
                category && category.children &&
                category.children.map((subCategory) => (
                  <Menu.Menu key={subCategory.title}>
                    <Menu.Item
                      key={`${category.title}-${subCategory.title}`}
                      onClick={
                        () => handleItemClick({
                          url: subCategory.url,
                          target: subCategory.target,
                        })
                      }
                    >
                      {subCategory.name[lang]}
                    </Menu.Item>
                  </Menu.Menu>
                ))
              }
            </Menu.Item>
          ))
        }
      </Menu>
    </MenuWrapper>
  )
}

ThemeCategoryMenus.propTypes = {
  menuId: PropTypes.string,
  categoryTitle: PropTypes.string,
  lang: PropTypes.string,
  backgroundColor: PropTypes.string,
  menu: PropTypes.array,
}

ThemeCategoryMenus.defaultProps = {
  menuId: '',
  categoryTitle: '',
  lang: 'en',
  backgroundColor: 'whiteMegaMenu',
  menu: [],
}

export default ThemeCategoryMenus



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/categoryMenus/ThemeCategoryMenus.js